const setStates = ({ commit }, payload) => {
  commit('SET_STATES', payload)
}

const setCities = ({ commit }, payload) => {
  commit('SET_CITIES', payload)
}

export { setStates, setCities }
